import { z } from 'zod'
import { optionFieldArray } from 'utils/zodHelpers'
import {
  AddEditAssetParamInterface,
  AssetCategoryInterface,
  AssetImageInterface,
} from '../@types/typeAddEditAsset'

export const requiredNumber = (field: string) =>
  z.preprocess(
    (v) => (v === '' || v === undefined || v === null ? undefined : Number(String(v))),
    z
      .number({ required_error: `${field} wajib diisi` })
      .refine((n) => n > 0, { message: `${field} harus lebih dari 0` })
      .refine((n) => !Number.isNaN(n), { message: `${field} harus berupa angka` }),
  ) as z.ZodType<number>

const stringRequired = (field: string) =>
  z
    .string({
      required_error: `${field} wajib diisi`,
    })
    .min(1, { message: `${field} wajib diisi` })

export const productAssetSchema: z.ZodType<AddEditAssetParamInterface> = z.object({
  name: stringRequired('Nama Produk'),
  sku_number: stringRequired('Nomor SKU'),
  uom: stringRequired('Uom Dasar'),
  type: stringRequired('Tipe Produk'),
  note: z.string(),
  asset_categories: optionFieldArray({
    required: true,
    requiredMessage: 'Kategori Produk wajib diisi',
    outputSchema: z.array(
      z.object({
        category_asset_id: z.string().or(z.number()),
        category_id: z.number().or(z.string()),
        category_name: z.string(),
        is_primary: z.boolean(),
      }),
    ),
  }) as z.ZodType<AssetCategoryInterface[]>,
  weight: requiredNumber('Berat'),
  length: requiredNumber('Panjang'),
  width: requiredNumber('Lebar'),
  height: requiredNumber('Tinggi'),
  status: z.string(),
  asset_images: optionFieldArray({
    required: true,
    requiredMessage: 'Foto Produk wajib diisi',
    outputSchema: z.array(
      z.object({
        url: z.string(),
        is_primary: z.boolean(),
      }),
    ),
  }) as z.ZodType<AssetImageInterface[]>,
})

export type ProductAssetSchemaType = z.infer<typeof productAssetSchema>

export const productAssetFieldNames = (
  productAssetSchema as z.ZodObject<Record<keyof ProductAssetSchemaType, z.ZodAny>>
).keyof().Enum
